import PropTypes from 'prop-types';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { MdDelete, MdEdit } from 'react-icons/md';
import {
  DivNoDataStyled,
  IconActionsStyled,
  TableCellHeaderStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
} from './MainTable.styles';

export function MainTable(props) {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem('user'));

  const {
    headings,
    searchTerm,
    keys,
    data,
    editActions,
    deleteAction,
    setOpenDialog,
    setConstructionId,
    callbackClickRow,
  } = props;

  function startEditing(item) {
    const edit = item;
    navigate(`/new-construction/${edit.id}`);
  }

  return (
    <TableContainerStyled id="suppliers-table" component={Paper}>
      <Table stickyHeader>
        <TableHeadStyled>
          <TableRow>
            {headings.map((heading) => (
              <TableCellHeaderStyled key={heading}>
                {heading}
              </TableCellHeaderStyled>
            ))}
            {editActions && (
              <TableCellHeaderStyled
                style={{
                  textAlign: 'center',
                }}
                key="action"
              >
                Ações
              </TableCellHeaderStyled>
            )}
          </TableRow>
        </TableHeadStyled>
        <TableBody>
          {data.length !== 0 &&
            data.map((row, index) => (
              <TableRowStyled key={row.id}>
                {keys.map((cell) => {
                  let label = '';
                  if (cell === 'users[0].name') {
                    if (
                      row.users.length > 1 &&
                      row.users[0].name === user.name
                    ) {
                      label = row.users[1].name;
                    } else {
                      label = row.users[0].name;
                    }
                  } else {
                    label = row[cell];
                  }

                  return (
                    <TableCell
                      style={{
                        fontSize: '12px',
                      }}
                      key={`cell-${cell}-${row.id}`}
                      onClick={() => callbackClickRow(data[index])}
                    >
                      {label}
                    </TableCell>
                  );
                })}
                {editActions && (
                  <TableCell
                    style={{
                      width: '100%',
                      fontSize: '12px',
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <IconActionsStyled
                      key="edit"
                      onClick={() => startEditing(row, index)}
                      size="large"
                    >
                      <MdEdit size={20} />
                    </IconActionsStyled>
                    {deleteAction && (
                      <IconActionsStyled
                        key="remove"
                        onClick={() => {
                          setOpenDialog(true);
                          setConstructionId(row.id);
                        }}
                        size="large"
                      >
                        {' '}
                        <MdDelete size={20} />
                      </IconActionsStyled>
                    )}
                  </TableCell>
                )}
              </TableRowStyled>
            ))}
        </TableBody>
      </Table>
      {!data.length && (
        <>
          {' '}
          <DivNoDataStyled>
            <Typography variant="h3" style={{ color: '#1c1c1ccc' }}>
              {searchTerm !== ''
                ? 'Não encontramos resultados para sua busca.'
                : 'Não existem itens cadastrados.'}
            </Typography>
          </DivNoDataStyled>
        </>
      )}
    </TableContainerStyled>
  );
}

MainTable.propTypes = {
  headings: PropTypes.arrayOf(PropTypes.string).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number,
    })
  ).isRequired,
  callbackClickRow: PropTypes.func,
  editActions: PropTypes.bool,
  deleteAction: PropTypes.bool,
  setOpenDialog: PropTypes.func,
  setConstructionId: PropTypes.func,
  searchTerm: PropTypes.string,
};

MainTable.defaultProps = {
  callbackClickRow: () => {},
  editActions: false,
  deleteAction: false,
  setOpenDialog: () => {},
  setConstructionId: () => {},
  searchTerm: '',
};
